import React from 'react';

const RadioButton = ({
  value,
  label,
  checked,
  onRadioChange,
}: {
  value: string;
  label: string;
  checked: string;
  onRadioChange: (e: string) => void;
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onRadioChange(event.target.value);
  };

  return (
    <div>
      <label className='radio'>
        <input type='radio' value={value} checked={checked === value} onChange={handleChange} />
        {label}
      </label>
    </div>
  );
};

export default RadioButton;
